import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  transferredProducts: {
    id: 'z5p+gU',
    defaultMessage: 'Transferred Products',
    description: 'Section title for transferred products',
  },
  noProductsPlaceholder: {
    id: 'ANZrMK',
    defaultMessage: 'No products in this transfer order',
    description: 'Placeholder when there are no products',
  },
  productNameColumnHeader: {
    id: 'BYJ3n3',
    defaultMessage: 'Product Name',
    description: 'Column header for product name',
  },
  receivedColumnHeader: {
    id: '9U/r/c',
    defaultMessage: 'Received',
    description: 'Column header for received count',
  },
  lotColumnHeader: {
    id: 'CMmGZ0',
    defaultMessage: 'Lot ID',
    description: 'Column header for lot',
  },
  sku: {
    id: 'SKydAb',
    defaultMessage: 'SKU: {sku}',
    description: 'Product SKU display',
  },
});
